export default __webpack_public_path__ + "static/media/msg.218f673c.png";